@if (quickLink && homeworkService.isQuickLinkExercise(quickLink) && !quickLink.menu && sidebarService.activeComponent === TasksComponent && homeworkService.isHomeworkEditorOpened() && hasPermissionToShow && !isPageQuickLink) {
    @if (!isDeactivated) {
        <button (click)="doAction($event)" [class.quick-add]="!addedToHomework"
             [class.quick-remove]="addedToHomework" [ngStyle]="{
        'top.%': quickLink.position.y,
        'left.%': quickLink.position.x,
        'height.%': quickLink.position.h * 1.2,
        'width.%': quickLink.position.h * 9,
        'border-radius.px': 20
     }" class="quick-overlay">
            @if (addedToHomework) {
                <div [ngStyle]="{ 'background-image': removeImage }" class="quick-img"></div>
            }
            @if (!addedToHomework) {
                <div [ngStyle]="{ 'background-image': addImage }" class="quick-img"></div>
            }
            <div class="quick-box">
                <span class="quick-text float-end">{{ linkText }}</span>
            </div>
        </button>
    }
    @if (isDeactivated) {
        <div [attr.data-bs-placement]="tooltipPosition" [ngStyle]="{
        'top.%': quickLink.position.y,
        'left.%': quickLink.position.x,
        'height.%': quickLink.position.h * 1.2,
        'width.%': quickLink.position.h * 9,
        'border-radius.px': 20
     }"
             class="quick-overlay disabled"
             data-bs-html="true"
             data-bs-toggle="tooltip"
             title="Dieses Beispiel steht zur<br/> Zeit nicht digital zur Verfügung.">
            <div class="quick-box">
                <span class="quick-text float-end">{{ linkText }}</span>
            </div>
        </div>
    }
}
